import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import triviapic from './torah trivia.png';
import puzzlepic from './puzzle.png';

const games = [
  {
    title: 'Torah Trivia',
    description: 'Who / where / what and fill-in-the-blank questions from the Five Books of Moses.',
    to: '/TorahTrivia',
    image: triviapic,
    action: 'Play',
  },
  {
    title: 'Torah Puzzle',
    description: 'A Torah-themed puzzle game for pattern solving, recognition, and challenge.',
    to: '/TorahPuzzle',
    image: puzzlepic,
    action: 'Play',
  },
];

export default function Game() {
  return (
    <div className="mainInner gamesPage">
      <div className="gamesHeader">
        <h2 style={{ margin: 0, color: '#0b1b2a' }}>Games</h2>
        <p style={{ marginTop: 6, marginBottom: 0, color: '#0b1b2a', opacity: 0.9 }}>
          Choose a game to play.
        </p>
      </div>

      <div className="gamesGrid">
        {games.map((game) => (
          <Link
            key={game.title}
            to={game.to}
            className="gameCardLink"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <div className="gameCard">
              <img src={game.image} alt={game.title} className="gameCardImage" />

              <div className="gameCardBody">
                <div>
                  <div className="gameCardTitle">{game.title}</div>
                  <div className="gameCardText">{game.description}</div>
                </div>

                <div className="gameCardAction">{game.action}</div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}